import { Input, Spin } from 'antd';
import { useAppSelector } from 'app/store';
import { viewerModel } from 'entities/viewer';
import AcceptSettingsTable from 'features/tables/accept-settings-table';
import React, { useEffect, useState } from 'react';
import { dataForAcceptSettingsTable } from 'shared/helpers/utils';
import { VACATION_SCHEDULE_ACCEPT_SETTINGS_COLUMN } from 'shared/constants/columns';
import {
  TAddApplicationStepResponse,
  TGetVacationApplicationsRequest,
  TPreparedAcceptSettingsColumns,
} from 'shared/types/vacation-schedule.types';
import { useGetStepsMutation, useLazyGetDivisionsSupervisorsQuery } from 'app/services/edpApiV1/vacationApplication';
import { getAllAvailableOrganizations } from 'entities/organizations/model/organizations';
import AcceptSettingsDrawer from '../accept-settings-drawer/AcceptSettingsDrawer';
import style from './index.module.scss';

const AcceptSettings = () => {
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [currentSize, setCurrentSize] = useState<number>(10);
  const [search, setSearch] = useState<string | null>(null);
  const [drawerOpen, setDrawerOpen] = useState<boolean>(false);
  const { role } = useAppSelector(viewerModel.me.selectors.selectViewerProfile);
  const [getSupervisors, { data, isFetching, isLoading }] = useLazyGetDivisionsSupervisorsQuery();
  const [stepMutation, { data: stepInfo }] = useGetStepsMutation();
  const meOrganizationId = useAppSelector(viewerModel.me.selectors.getMeOrganizationId);
  const allAvailableOrganizations = useAppSelector(getAllAvailableOrganizations);

  useEffect(() => {
    const searchObject: TGetVacationApplicationsRequest = { page: currentPage, size: currentSize };
    if (allAvailableOrganizations) {
      searchObject.organizationId = undefined;
    } else if (meOrganizationId) {
      searchObject.organizationId = meOrganizationId;
    }
    if (search) {
      searchObject.search = search;
    }
    getSupervisors(searchObject);
  }, [currentPage, currentSize, meOrganizationId, search, allAvailableOrganizations]);

  const onclickToRow = (id: string) => {
    stepMutation({ divisionId: id });
    setDrawerOpen(true);
  };

  const onDrawerClose = () => {
    setDrawerOpen(false);
  };

  const onSearch = (data: string) => {
    setSearch(data);
  };

  const columns: TPreparedAcceptSettingsColumns = VACATION_SCHEDULE_ACCEPT_SETTINGS_COLUMN;
  return (
    <>
      <h3>Настройка согласования</h3>
      <Spin spinning={isFetching || isLoading}>
        <div className={style.wrap}>
          <div className={style.search}>
            <Input.Search
              placeholder="Введите подразделение или ФИО"
              className={style['search-input']}
              onSearch={onSearch}
              allowClear
            />
          </div>
          {data?.data ? (
            <AcceptSettingsTable
              dataSource={dataForAcceptSettingsTable(data?.data) || []}
              columns={columns}
              currentPage={currentPage}
              currentSize={currentSize}
              setCurrentPage={setCurrentPage}
              setCurrentSize={setCurrentSize}
              total={data?.pagination.total}
              onclickToRow={data => onclickToRow(data)}
            />
          ) : null}
        </div>
      </Spin>
      <AcceptSettingsDrawer
        stepInfo={stepInfo as TAddApplicationStepResponse | undefined}
        onDrawerClose={onDrawerClose}
        drawerOpen={drawerOpen}
      />
    </>
  );
};

export default AcceptSettings;
